import script from "./AdminServersView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminServersView.vue?vue&type=script&setup=true&lang=js"

import "./AdminServersView.vue?vue&type=style&index=0&id=6c982954&lang=css"

const __exports__ = script;

export default __exports__